/* eslint-disable react-refresh/only-export-components */
/**
 * Tabs — re-exports of Radix Tabs with Aurora styling baked in.
 *
 * Usage:
 *   <Tabs defaultValue="all">
 *     <TabsList>
 *       <TabsTrigger value="all">All</TabsTrigger>
 *       <TabsTrigger value="meraki">Meraki</TabsTrigger>
 *     </TabsList>
 *     <TabsContent value="all">…</TabsContent>
 *   </Tabs>
 */
import * as RadixTabs from "@radix-ui/react-tabs";

export const Tabs = RadixTabs.Root;
export { TabsList } from "./tabs-list";
export { TabsTrigger } from "./tabs-trigger";
export { TabsContent } from "./tabs-content";
